import Popover from './Popover';
import {ClosablePopover, withClosablePopover} from "./ClosablePopover";

export default Popover;

export {
	Popover,
	withClosablePopover,
	ClosablePopover
};